import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=524c0d76"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"
import style0 from "./Password.vue?vue&type=style&index=0&id=524c0d76&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524c0d76')) {
      api.createRecord('524c0d76', component.options)
    } else {
      api.reload('524c0d76', component.options)
    }
    module.hot.accept("./Password.vue?vue&type=template&id=524c0d76", function () {
      api.rerender('524c0d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/Password/Password.vue"
export default component.exports